/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { BannerProps, BannerType, IconName } from '../../types';
import Icon from '../Icon/Icon';
import './Banner.less';

const DEFAULT_ICONS: Record<BannerType, IconName> = {
  error: 'miscellaneous/error-outline',
  warning: 'miscellaneous/warning-outline',
  info: 'miscellaneous/info-outline',
  success: 'miscellaneous/success-outline',
};

const Banner = React.forwardRef<HTMLDivElement, BannerProps>(
  ({ type, title, children, icon, onClose, className }, ref) => (
    <div
      ref={ref}
      role={type === 'error' || type === 'warning' ? 'alert' : undefined}
      className={cx('banner', `banner--${type}`, className)}>
      <Icon name={icon ?? DEFAULT_ICONS[type]} size="large" className="banner__icon" />
      <div className="banner__body">
        {title && <span className="banner__title">{title}</span>}
        {children && <span className="banner__message">{children}</span>}
      </div>
      {onClose && (
        <button className="banner__close" onClick={onClose} aria-label="Dismiss">
          <Icon name="actionable/close" size="small" />
        </button>
      )}
    </div>
  )
);

Banner.displayName = 'Banner';

export default Banner;
